module.exports = __webpack_public_path__ + "assets/img/326301.8313ab96.svg";